import { rem } from "@mantine/core";
import styled from "styled-components";

import { marginInlineAuto } from "@styles/Utilities.styled";


export const StyledInviteUser = styled.section`
  .form {
    padding: 1.5rem 2rem;
    margin-top: 2rem;
    margin-bottom: 8rem;
    border: 1px solid var(--clr-gray-200);
    border-radius: var(--border-radius-3);
    max-width: ${rem(400)};
    /* ${marginInlineAuto(`min(100%, ${rem(400)})`)} */
  }
`;
